module.exports = __webpack_public_path__ + "img/155.cc459a60.jpg";